import style from '../../component/common/style/index.scss';
import { formatDate,tableDateFormatter} from '../../common/utils/index'
import { Tooltip } from './../../component/common/ToolTip/ToolTip';
const gradeScale = ['Group', 'Year'];
function statuscellClass(params) {
    return (params.value == 'Below') ? [ style.fontCls, style.raRed].join(" ") : [ style.fontCls].join(" ");
}
function customTooltip(description) {
    let tooltip = [];
    tooltip.description = description;
    tooltip.tags = [];
    return Tooltip(tooltip);
}

let defaultConfig = {
    columnsdef: [
        {
            headerName: "Assesment name",
             field: "assessmentName",
              sortable: true,
               unSortIcon: true, 
               sortingOrder: ['asc'],
               wrapText:true,
               autoHeight:true,
               minWidth: 200, 
            cellClass: [style.uIdcolumn, style.fontCl, style.rmvLine].join(' '),
            cellRenderer: (params) => {
                let assessmentName = params.data.assessmentName
                return `<span class="assessment-name" >${assessmentName}</span>`;
            }
             
        },
        {
            headerName: "Date", autoHeight:true,field: "assessmentDateFormatted",unSortIcon: true, 
            sort:'desc',
            sortingOrder: ['asc','desc'], sortable: true, minWidth: 120, cellClass: [ style.fontCl].join(' '),
            type: ['dateColumn', 'nonEditableColumn'],
            valueFormatter: (params) => {
                return tableDateFormatter(params)
            }
        },
        {
            headerName: "Indicative grade", autoHeight: true, field: "indicativeGradeValue", unSortIcon: true, sortingOrder: ['asc'], sortable: true, minWidth: 170, cellClass: [style.centerCls, style.fontCls].join(" ")
        },
        {
            headerName: "Step", autoHeight: true,field: "stepValue", unSortIcon: true, minWidth: 90, sortingOrder: ['asc'], sortable: true, cellClass: [style.centerCls, style.fontCls].join(" ")
        },
        {

            headerName: "Percentage", autoHeight: true, field: "percentage", minWidth: 160, unSortIcon: true, sortingOrder: ['asc'], sortable: true, cellClass: [style.centerCls, style.fontCls].join(" "),
            valueGetter(a){
                return `${a.data.percentage} %`
            }

        },
        {
            headerName: "Mark", autoHeight: true, field: "studentAssessmentMarks", minWidth: 90, unSortIcon: true, sortingOrder: ['asc'], sortable: true, cellClass: [style.centerCls, style.fontCls].join(" "),
            valueGetter(a) {
                return `${a.data.studentAssessmentMarks}/${a.data.assessmentMaxMarks}`
            }
        },
        {
            headerName: "On track?",
             field: "onTrack",
              minWidth: 148,
               sortingOrder: ['asc'],
                sortable: true, 
                unSortIcon: true, 
                autoHeight: true,
                cellClass: statuscellClass,
                headerTooltip: customTooltip(`This assessment result indicates the student is ‘on or above’ or ‘below’ track to meet their course target.
                Based on linear progress from baseline to course target (excluding unit tests).`),
            headerComponentParams: {
                menuIcon: 'fa-bars',
                template:
                '<div class="ag-cell-label-container" role="presentation">' +
                '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
                '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
                '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
                '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
                '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
                '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
                '    <span ref="eText" class="ag-header-cell-text" role="columnheader"></span>  &nbsp;' +
                '    <span ref="eText" class="question-tooltip-icon question-tooltip-paddingWidget" role="columnheader"></span>' +
                '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
                '  </div>' +
                '</div>'
            },

        },
        {
            headerName: "Progress",
             field: "progress",
              minWidth: 150,
               sortingOrder: ['asc'], 
               sortable: true,               
               unSortIcon: true,
               autoHeight: true,
                cellClass: [style.centerCls, style.fontCls].join(" "),
                headerTooltip: customTooltip(`Progress is the difference in indicative grades between this assessment and the baseline test (excluding unit tests).`),
            headerComponentParams: {
                menuIcon: 'fa-bars',
                template:
                '<div class="ag-cell-label-container" role="presentation">' +
                '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
                '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
                '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
                '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
                '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
                '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
                '    <span ref="eText" class="ag-header-cell-text" role="columnheader"></span>  &nbsp;' +
                '    <span ref="eText" class="question-tooltip-icon question-tooltip-paddingWidget" role="columnheader"></span>' +
                '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
                '  </div>' +
                '</div>'
            },

        },
        {
            headerName: "Group average indicative grade", autoHeight: true, sortingOrder: ['asc'], unSortIcon: true, field: "groupGradeAverage", minWidth: 300, sortable: true, cellClass: [style.centerCls, style.fontCls].join(" ")
        },
        {
            headerName: "Group average steps",autoHeight:true, field: "groupStepAgerage", sortingOrder: ['asc'], unSortIcon: true, minWidth: 240, sortable: true, cellClass: [style.centerCls, style.fontCls].join(" ")
        },
        {

            headerName: "Group average percentage",autoHeight:true, field: "groupAveragePercentage", sortingOrder: ['asc'], unSortIcon: true, minWidth: 250, sortable: true, cellClass: [style.centerCls, style.fontCls].join(" "),
            valueGetter(a){
                return `${a.data.groupAveragePercentage} %`
            }

        },
        {
            headerName: "Group average mark", autoHeight:true,field: "groupAverageScore", sortingOrder: ['asc'], unSortIcon: true, minWidth: 200, sortable: true, cellClass: [style.centerCls, style.fontCls].join(" "),
            valueGetter(a) {
                return `${a.data.groupAverageScore}/${a.data.assessmentMaxMarks}`
            }
        },
        {
            headerName: "Year average indicative grade",autoHeight:true, field: "yearGradeAverage", sortingOrder: ['asc'], unSortIcon: true, minWidth: 280, sortable: true, cellClass: [style.centerCls, style.fontCls].join(" ")
        },
        {
            headerName: "Year average steps", autoHeight:true,field: "yearStepAgerage", minWidth: 240, sortingOrder: ['asc'], unSortIcon: true, sortingOrder: ['asc'], sortable: true, sortable: true, cellClass: [style.centerCls, style.fontCls].join(" ")
        },
        {

            headerName: "Year average percentage",autoHeight:true, field: "yearAveragePercentage", sortingOrder: ['asc'], unSortIcon: true, minWidth: 250, sortable: true, cellClass: [style.centerCls, style.fontCls].join(" "),
            valueGetter(a){
                return `${a.data.yearAveragePercentage} %`
            }

        },
        {
            headerName: "Year average mark",autoHeight:true, field: "yearAverageScore", minWidth: 200, sortingOrder: ['asc'], unSortIcon: true, unSortIcon:true, sortable: true, cellClass: [style.centerCls, style.fontCls].join(" "),
            valueGetter(a) {
                return `${a.data.yearAverageScore}/${a.data.assessmentMaxMarks}`
            }
        }

    ]
   

};

export default defaultConfig;



export const convertColumndef = (viewBy, assessmentConfig) => {

    let columnsArray = [];
    let removeColumn = (viewBy == 'indicativeGradeValue') ? ['stepValue', 'yearStepAgerage', 'groupStepAgerage'] : ['indicativeGradeValue', 'groupGradeAverage','yearGradeAverage'];
    assessmentConfig.columnsdef.map((val) => {
        if ( removeColumn.indexOf(val['field'])==-1) {
            if (val['field'] == 'onTrack') {
                val['cellClass'] = statuscellClass;
            }
            columnsArray.push(val)
        }
    })
    return columnsArray;
}

export const convertRowData = (assessmentConfig) => { 
    let rowData=[];
    assessmentConfig.rowData.map((val)=>{
        val.assessmentDateFormatted =val.assessmentDate
    })  
    return assessmentConfig.rowData;
}